import {forwardRef} from 'react';
import cx from 'classnames';
import {isNumber} from 'lodash';
import {isFinite} from 'lodash';

import {theme} from '#theme';

import {TallyLogoProps} from './TallyLogo.types';

import {responsiveStyles} from './TallyLogo.css';

// The logo has to have a specific aspect ratio based on the original image.
const ASPECT_RATIO = 119 / 70;
const DEFAULT_WIDTH = 420;

export const TallyLogo = forwardRef<SVGSVGElement, TallyLogoProps>(
  (
    {className, color = 'burgundy', isResponsive = false, size: propsSize, sizeType: propsSizeType},
    ref,
  ) => {
    const renderedColor = theme.colors[color];
    let width = DEFAULT_WIDTH;
    let height = width / ASPECT_RATIO;

    if (isNumber(propsSize) && isFinite(propsSize) && propsSize > 0) {
      const sizeType = propsSizeType || 'width';

      if (sizeType === 'width') {
        width = propsSize;
        height = width / ASPECT_RATIO;
      } else if (sizeType === 'height') {
        height = propsSize;
        width = height * ASPECT_RATIO;
      }
    }

    return (
      <svg
        aria-label="Tally Health™"
        className={cx(className, {[responsiveStyles]: isResponsive})}
        fill={renderedColor}
        height={isResponsive ? undefined : height}
        ref={ref}
        viewBox="0 0 82 48"
        width={isResponsive ? undefined : width}
        xmlns="http://www.w3.org/2000/svg">
        <title>Tally Health</title>
        <path d="M38.059 1.744v36.51h5.75V0M46.853 1.744v36.51h5.75V0M17.319 32.66c-1.266 1.118-2.62 1.612-4.162 1.612-2.144 0-3.996-1.276-3.996-4.317V18.921h6.677l1.559-2.648H9.16v-5.886L0 17.548l3.801 2.207-.243 12.114c0 4.217 2.972 6.474 6.48 6.474 3.274 0 6.322-2.28 7.28-5.657v-.026ZM78.338 15.923h-.578v1.358h-.381v-1.358h-.58v-.342h1.54v.342ZM81.032 15.581v1.7h-.368v-1.35l-.093.295-.415 1.055h-.472l-.415-1.055-.092-.29v1.345h-.368v-1.7h.648l.347.98.116.352.116-.349.347-.983h.65ZM61.715 47.615 75.74 15.6l-2.717-.004-7.143 16.284-5.842-16.3-6.376-.009L62.89 38.71l-3.916 8.905h2.742ZM29.363 33.29c-.925.834-1.997 1.325-3.265 1.325-1.608 0-2.924-.932-2.924-2.649 0-2.157 1.462-3.138 4.046-4.267l2.143-.931v6.523Zm5.556-9.822v-2.144c0-3.924-2.388-6.229-5.605-6.229-4.775 0-10.185 3.679-11.841 8.24h6.042v-5.052c4.532-.931 5.848 1.374 5.848 4.267v2.453l-5.36 2.157c-3.363 1.325-6.287 3.09-6.287 6.376 0 2.845 2.34 4.66 4.874 4.66 2.826 0 4.873-1.865 6.091-3.287l.732-.963v4.299h5.506V23.468ZM9.806 41.31v6.304H8.39v-2.593H5.053v2.593H3.639V41.31h1.414v2.405H8.39V41.31h1.415ZM13.046 42.617v1.098h3.25v1.26h-3.25v1.334h3.41v1.306H11.65V41.31h4.806v1.307h-3.41ZM22.204 44.994l-.582-1.46-.44-1.125-1.028 2.585h2.049Zm.501 1.252h-3.051l-.547 1.37h-1.486l2.586-6.305h1.96l2.57 6.304H23.25l-.546-1.37ZM30.572 46.309v1.306h-4.734V41.31h1.424v4.999h3.31ZM36.275 42.58h-2.148v5.035h-1.415V42.58h-2.148V41.31h5.711v1.27ZM43.807 41.31v6.304h-1.413v-2.593h-3.338v2.593H37.64V41.31h1.415v2.405h3.338V41.31h1.413Z"></path>
      </svg>
    );
  },
);
